// Generated by Melange

import * as Caml_string from "melange.js/caml_string.js";
import * as Lui_extension from "lui/lui_extension.js";
import * as Lui_ui from "lui/lui_ui.js";
import * as Signal from "ocaml-signal/signal.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__Buffer from "melange/buffer.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__Option from "melange/option.js";
import * as Stdlib__String from "melange/string.js";

function $$escape(text) {
  const buffer = Stdlib__Buffer.create(text.length + 16 | 0);
  Stdlib__String.iter((function (c) {
    if (c === 34) {
      return Stdlib__Buffer.add_string(buffer, "&quot;");
    }
    if (c < 60) {
      if (c !== 38) {
        return Stdlib__Buffer.add_char(buffer, c);
      } else {
        return Stdlib__Buffer.add_string(buffer, "&amp;");
      }
    }
    if (c >= 63) {
      return Stdlib__Buffer.add_char(buffer, c);
    }
    switch (c) {
      case 60 :
        return Stdlib__Buffer.add_string(buffer, "&lt;");
      case 61 :
        return Stdlib__Buffer.add_char(buffer, c);
      case 62 :
        return Stdlib__Buffer.add_string(buffer, "&gt;");
    }
  }), text);
  return Stdlib__Buffer.contents(buffer);
}

function safe_url(url) {
  const lower = Stdlib__String.lowercase_ascii(Stdlib__String.trim(url));
  if (lower.length >= 8 && Stdlib__String.sub(lower, 0, 8) === "https://" || lower.length >= 7 && Stdlib__String.sub(lower, 0, 7) === "http://") {
    return lower;
  } else {
    return "";
  }
}

function close_at(text, marker, from) {
  const m = marker.length;
  const n = text.length;
  let _k = from;
  while (true) {
    const k = _k;
    if ((k + m | 0) > n) {
      return;
    }
    if (Stdlib__String.sub(text, k, m) === marker) {
      return k;
    }
    _k = k + 1 | 0;
    continue;
  };
}

function emit_span(buffer, tag, body) {
  Stdlib__Buffer.add_string(buffer, "<" + (tag + ">"));
  Stdlib__Buffer.add_string(buffer, $$escape(body));
  Stdlib__Buffer.add_string(buffer, "</" + (tag + ">"));
}

function inline(text) {
  const buffer = Stdlib__Buffer.create((text.length << 1));
  const n = text.length;
  const scan = function (_i) {
    while (true) {
      const i = _i;
      if (i >= n) {
        return;
      }
      const c = Caml_string.get(text, i);
      if (c !== 42) {
        if (c !== 91) {
          if (c !== 96) {
            Stdlib__Buffer.add_string(buffer, $$escape(Stdlib__String.make(1, c)));
            _i = i + 1 | 0;
            continue;
          }
          const j = close_at(text, "`", i + 1 | 0);
          if (j !== undefined && j > (i + 1 | 0)) {
            emit_span(buffer, "code", Stdlib__String.sub(text, i + 1 | 0, (j - i | 0) - 1 | 0));
            _i = j + 1 | 0;
            continue;
          }
          Stdlib__Buffer.add_string(buffer, $$escape("`"));
          _i = i + 1 | 0;
          continue;
        }
        const j$1 = close_at(text, "](", i + 1 | 0);
        if (j$1 !== undefined) {
          const k = close_at(text, ")", j$1 + 2 | 0);
          if (k !== undefined) {
            const label = Stdlib__String.sub(text, i + 1 | 0, (j$1 - i | 0) - 1 | 0);
            const url = safe_url(Stdlib__String.sub(text, j$1 + 2 | 0, (k - j$1 | 0) - 2 | 0));
            if (url !== "" && label !== "") {
              Stdlib__Buffer.add_string(buffer, "<a href=\"");
              Stdlib__Buffer.add_string(buffer, url);
              Stdlib__Buffer.add_string(buffer, "\" target=\"_blank\" rel=\"noopener noreferrer\">");
              Stdlib__Buffer.add_string(buffer, $$escape(label));
              Stdlib__Buffer.add_string(buffer, "</a>");
              _i = k + 1 | 0;
              continue;
            }
            Stdlib__Buffer.add_string(buffer, $$escape("["));
            _i = i + 1 | 0;
            continue;
          }
          Stdlib__Buffer.add_string(buffer, $$escape("["));
          _i = i + 1 | 0;
          continue;
        }
        Stdlib__Buffer.add_string(buffer, $$escape("["));
        _i = i + 1 | 0;
        continue;
      }
      if ((i + 1 | 0) < n && Caml_string.get(text, i + 1 | 0) === /* '*' */42) {
        const j$2 = close_at(text, "**", i + 2 | 0);
        if (j$2 !== undefined && j$2 > (i + 2 | 0)) {
          emit_span(buffer, "strong", Stdlib__String.sub(text, i + 2 | 0, (j$2 - i | 0) - 2 | 0));
          _i = j$2 + 2 | 0;
          continue;
        }
        Stdlib__Buffer.add_string(buffer, $$escape("*"));
        _i = i + 1 | 0;
        continue;
      }
      const j$3 = close_at(text, "*", i + 1 | 0);
      if (j$3 !== undefined && j$3 > (i + 1 | 0)) {
        emit_span(buffer, "em", Stdlib__String.sub(text, i + 1 | 0, (j$3 - i | 0) - 1 | 0));
        _i = j$3 + 1 | 0;
        continue;
      }
      Stdlib__Buffer.add_string(buffer, $$escape("*"));
      _i = i + 1 | 0;
      continue;
    };
  };
  scan(0);
  return Stdlib__Buffer.contents(buffer);
}

function fence_language(line) {
  return Stdlib__String.trim(Stdlib__String.sub(Stdlib__String.trim(line), 3, Stdlib__String.trim(line).length - 3 | 0));
}

function heading(line) {
  const marks = function (_i) {
    while (true) {
      const i = _i;
      if (!(i < line.length && Caml_string.get(line, i) === /* '#' */35)) {
        return i;
      }
      _i = i + 1 | 0;
      continue;
    };
  };
  const level = marks(0);
  if (level >= 1 && level <= 4 && level < line.length && Caml_string.get(line, level) === /* ' ' */32) {
    return [
      level,
      Stdlib__String.trim(Stdlib__String.sub(line, level + 1 | 0, (line.length - level | 0) - 1 | 0))
    ];
  }
  
}

function unordered(line) {
  const t = Stdlib__String.trim(line);
  if (t.length > 2 && Stdlib__List.mem(Caml_string.get(t, 0), {
      hd: /* '-' */45,
      tl: {
        hd: /* '*' */42,
        tl: {
          hd: /* '+' */43,
          tl: /* [] */ 0
        }
      }
    }) && Caml_string.get(t, 1) === /* ' ' */32) {
    return Stdlib__String.sub(t, 2, t.length - 2 | 0);
  }
  
}

function ordered(line) {
  const t = Stdlib__String.trim(line);
  const i = Stdlib__String.index_opt(t, /* '.' */46);
  if (i !== undefined && i >= 1 && i <= 3 && (i + 1 | 0) < t.length && Caml_string.get(t, i + 1 | 0) === /* ' ' */32 && Stdlib__String.for_all((function (param) {
      return !(param > 57 || param < 48);
    }), Stdlib__String.sub(t, 0, i))) {
    return Stdlib__String.sub(t, i + 2 | 0, (t.length - i | 0) - 2 | 0);
  }
  
}

function quote(line) {
  const t = Stdlib__String.trim(line);
  if (Stdlib__String.starts_with(">", t)) {
    return Stdlib__String.trim(Stdlib__String.sub(t, 1, t.length - 1 | 0));
  }
  
}

function rule(line) {
  const t = Stdlib__String.trim(line);
  if (t.length >= 3) {
    if (Stdlib__String.for_all((function (param) {
        return /* '-' */45 === param;
      }), t) || Stdlib__String.for_all((function (param) {
        return /* '*' */42 === param;
      }), t)) {
      return true;
    } else {
      return Stdlib__String.for_all((function (param) {
        return /* '_' */95 === param;
      }), t);
    }
  } else {
    return false;
  }
}

function code_block(buffer, language, body) {
  Stdlib__Buffer.add_string(buffer, "<div class=\"md-code\"><div class=\"md-bar\"><span>");
  Stdlib__Buffer.add_string(buffer, $$escape(language === "" ? "code" : language));
  Stdlib__Buffer.add_string(buffer, "</span><button type=\"button\" class=\"md-copy\">Copy</button></div><pre><code>");
  Stdlib__Buffer.add_string(buffer, $$escape(body));
  Stdlib__Buffer.add_string(buffer, "</code></pre></div>");
}

function list_close(buffer, state) {
  if (state.contents !== "") {
    Stdlib__Buffer.add_string(buffer, "</" + (state.contents + ">"));
    state.contents = "";
    return;
  }
  
}

function blocks(buffer, state, _param) {
  while (true) {
    const param = _param;
    if (!param) {
      return;
    }
    const line = param.hd;
    const rest = param.tl;
    if (Stdlib__String.trim(line) === "") {
      list_close(buffer, state);
      _param = rest;
      continue;
    }
    if (Stdlib__String.starts_with("```", Stdlib__String.trim(line))) {
      list_close(buffer, state);
      let language = fence_language(line);
      let _rest = rest;
      let _acc = /* [] */ 0;
      while (true) {
        const acc = _acc;
        const rest$1 = _rest;
        if (!rest$1) {
          return code_block(buffer, language, Stdlib__String.concat("\n", Stdlib__List.rev(acc)));
        }
        const line$1 = rest$1.hd;
        if (Stdlib__String.starts_with("```", Stdlib__String.trim(line$1))) {
          code_block(buffer, language, Stdlib__String.concat("\n", Stdlib__List.rev(acc)));
          return blocks(buffer, state, rest$1.tl);
        }
        _acc = {
          hd: line$1,
          tl: acc
        };
        _rest = rest$1.tl;
        continue;
      };
    }
    const rest$2 = param.tl;
    const match = heading(line);
    if (match !== undefined) {
      const level = match[0];
      list_close(buffer, state);
      Stdlib__Buffer.add_string(buffer, "<h" + (String(level) + ">"));
      Stdlib__Buffer.add_string(buffer, inline(match[1]));
      Stdlib__Buffer.add_string(buffer, "</h" + (String(level) + ">"));
      _param = rest$2;
      continue;
    }
    const item = unordered(line);
    if (item !== undefined) {
      if (state.contents !== "ul") {
        list_close(buffer, state);
        Stdlib__Buffer.add_string(buffer, "<ul>");
        state.contents = "ul";
      }
      Stdlib__Buffer.add_string(buffer, "<li>");
      Stdlib__Buffer.add_string(buffer, inline(item));
      Stdlib__Buffer.add_string(buffer, "</li>");
      _param = rest$2;
      continue;
    }
    const item$1 = ordered(line);
    if (item$1 !== undefined) {
      if (state.contents !== "ol") {
        list_close(buffer, state);
        Stdlib__Buffer.add_string(buffer, "<ol>");
        state.contents = "ol";
      }
      Stdlib__Buffer.add_string(buffer, "<li>");
      Stdlib__Buffer.add_string(buffer, inline(item$1));
      Stdlib__Buffer.add_string(buffer, "</li>");
      _param = rest$2;
      continue;
    }
    const content = quote(line);
    if (content !== undefined) {
      list_close(buffer, state);
      Stdlib__Buffer.add_string(buffer, "<blockquote><p>");
      Stdlib__Buffer.add_string(buffer, inline(content));
      Stdlib__Buffer.add_string(buffer, "</p></blockquote>");
      _param = rest$2;
      continue;
    }
    if (!rule(line)) {
      let _rest$1 = rest$2;
      let _acc$1 = {
        hd: line,
        tl: /* [] */ 0
      };
      while (true) {
        const acc$1 = _acc$1;
        const rest$3 = _rest$1;
        if (!rest$3) {
          return emit_paragraph(buffer, state, acc$1, rest$3);
        }
        const line$2 = rest$3.hd;
        if (!(Stdlib__String.trim(line$2) !== "" && !Stdlib__String.starts_with("```", Stdlib__String.trim(line$2)))) {
          return emit_paragraph(buffer, state, acc$1, rest$3);
        }
        const match$1 = heading(line$2);
        const match$2 = unordered(line$2);
        const match$3 = ordered(line$2);
        const match$4 = quote(line$2);
        if (match$1 === undefined && match$2 === undefined && match$3 === undefined && match$4 === undefined && !rule(line$2)) {
          _acc$1 = {
            hd: line$2,
            tl: acc$1
          };
          _rest$1 = rest$3.tl;
          continue;
        }
        return emit_paragraph(buffer, state, acc$1, rest$3);
      };
    }
    list_close(buffer, state);
    Stdlib__Buffer.add_string(buffer, "<hr>");
    _param = rest$2;
    continue;
  };
}

function emit_paragraph(buffer, state, acc, rest) {
  list_close(buffer, state);
  Stdlib__Buffer.add_string(buffer, "<p>");
  Stdlib__List.iteri((function (i, line) {
    if (i > 0) {
      Stdlib__Buffer.add_string(buffer, "<br>");
    }
    Stdlib__Buffer.add_string(buffer, inline(line));
  }), Stdlib__List.rev(acc));
  Stdlib__Buffer.add_string(buffer, "</p>");
  blocks(buffer, state, rest);
}

function to_html(text) {
  const buffer = Stdlib__Buffer.create(text.length + 256 | 0);
  const state = {
    contents: ""
  };
  blocks(buffer, state, Stdlib__String.split_on_char(/* '\n' */10, text));
  list_close(buffer, state);
  return Stdlib__Buffer.contents(buffer);
}

const identifier = "mapre-markdown";

function copy_click($$event) {
  const origin = $$event.target;
  const button = origin.closest(".md-copy");
  if (button == null) {
    return false;
  }
  const block = button.closest(".md-code");
  if (block == null) {
    return false;
  } else {
    navigator.clipboard.writeText(block.textContent).then(function (param) {
      button.textContent = "Copied";
      return Promise.resolve();
    });
    return true;
  }
}

function create(_node, $$document, _emit) {
  const el = $$document.createElement("div");
  el.className = "md";
  const click = function ($$event) {
    copy_click($$event);
  };
  el.__mapreMd = {
    click
  };
  el.addEventListener("click", click);
  return el;
}

function set_property(el, key, property) {
  if (key !== "markdown") {
    return Stdlib.invalid_arg("invalid_markdown_property");
  }
  if (property.TAG === /* StringValue */ 0) {
    el.innerHTML = to_html(property._0);
    return;
  }
  el.innerHTML = "";
}

function adapter_web_extension_remove_property(el, key) {
  if (key !== "markdown") {
    return Stdlib.invalid_arg("invalid_markdown_property");
  }
  el.innerHTML = "";
}

function adapter_web_extension_cleanup(el) {
  el.removeEventListener("click", el.__mapreMd.click);
}

const adapter = {
  web_extension_create: create,
  web_extension_set_property: set_property,
  web_extension_remove_property: adapter_web_extension_remove_property,
  web_extension_cleanup: adapter_web_extension_cleanup
};

function component(param) {
  return Lui_extension.component(identifier, {
    hd: {
      profile_os: /* WebOS */ 1,
      profile_host: /* WebHost */ 1
    },
    tl: /* [] */ 0
  }, false, /* [] */ 0, {
    hd: Lui_extension.property("markdown", /* StringScalar */ 0, false, undefined),
    tl: /* [] */ 0
  }, /* [] */ 0);
}

function view(source, context, parent) {
  const node = Lui_ui.extension(context, identifier);
  Lui_ui.extension_property_signal(context, node, "markdown", Signal.map((function (text) {
    return {
      TAG: /* StringValue */ 0,
      _0: text
    };
  }), source));
  Stdlib__Option.iter((function (parent) {
    Lui_ui.append(context, parent, node);
  }), parent);
  return node;
}

export {
  identifier,
  to_html,
  component,
  adapter,
  view,
}
/* Lui_extension Not a pure module */
